import { styled } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {
  useDiscussionActionContext,
  useDiscussionStateContext,
} from '../../context/DiscussionContext'
import { intl } from '../../../../../i18n'
import { colorPalette } from '../../../../style/colorPalette'

type AppliedFilterChipProps = {
  resultCount: number
}

export const AppliedFilterChip = ({ resultCount }: AppliedFilterChipProps) => {
  const { targetCandidates, selectedTargetUuid } = useDiscussionStateContext()
  const { setSelectedTargetUuid } = useDiscussionActionContext()

  if (!selectedTargetUuid) return null

  const selected = targetCandidates.find(c => c.uuid === selectedTargetUuid)
  if (!selected) return null

  return (
    <Container>
      <Chip>
        <ChipValue>{selected.name}</ChipValue>
        <ChipRemove
          type="button"
          onClick={() => setSelectedTargetUuid(null)}
          aria-label="clear filter"
        >
          <CloseIcon fontSize="inherit" />
        </ChipRemove>
      </Chip>
      <ResultCount>
        {intl.formatMessage(
          { id: 'discussion.filter.results' },
          { n: resultCount }
        )}
      </ResultCount>
    </Container>
  )
}

const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '4px 12px',
  borderBottom: `1px solid ${colorPalette.monotone[2]}`,
})

const Chip = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  height: '20px',
  padding: '0 4px 0 8px',
  borderRadius: '10px',
  backgroundColor: colorPalette.skyBlue[1],
  color: colorPalette.skyBlue[10],
  fontSize: '11px',
  fontWeight: 600,
  maxWidth: 'calc(100% - 50px)',
  overflow: 'hidden',
})

const ChipValue = styled('span')({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

const ChipRemove = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '14px',
  height: '14px',
  padding: 0,
  border: 'none',
  borderRadius: '50%',
  backgroundColor: 'transparent',
  color: 'inherit',
  cursor: 'pointer',
  fontSize: '12px',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: colorPalette.skyBlue[2],
  },
})

const ResultCount = styled('span')({
  marginLeft: 'auto',
  fontSize: '11px',
  color: colorPalette.monotone[5],
  flexShrink: 0,
})
